import { hideModal } from '@shared/ui/modal.util';

class SuccessModalController {
  constructor($state) {
    'ngInject';

    this.$state = $state;
  }

  clickedOk() {
    hideModal('successModal');
    this.$state.go('overview');
  }
}

export default SuccessModalController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/success.modal.controller.js